
<template>
    <div>
        <q-card class="text-caption">
            <q-card-section>
                <div>EMPLOYMENT INFORMATION</div>
            </q-card-section>
            <q-separator/>
            <q-card-section>
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Employment Status
                    </div>
                    <div class="col">
                        : {{StoreStateED.EmploymentStatus}}
                    </div>
                </div>    
                <div class="row q-pb-sm">
                    <div class="col-4">
                        Designation
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.EmploymentInformation.Designation}}
                    </div>
                </div>
                <div class="row  q-pb-sm">
                    <div class="col-4">
                        Nature of Business
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.EmploymentInformation.BusinessNature}}
                    </div>
                 </div>   
                <div class="row  q-pb-sm">
                    <div class="col-4">
                        Nature of Business, Others
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.EmploymentInformation.BusinessNatureOth}}
                    </div>
                </div>
                <div class="row  q-pb-sm">
                    <div class="col-4">
                        Employer Name
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.EmploymentInformation.EmployerName}}
                    </div>
                </div>
                <div class="q-pb-sm">
                        EMPLOYER ADDRESS
                    </div>
                <div class="row  q-pb-sm">
                    <div class="col-4">
                        Address 1
                    </div>
                    <div class="col">
                        : {{StoreStateAOD.EmploymentInformation.EmployerAddress.Address1}}
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'SummaryEmploymentInformation',
    data() {
        return {
            StoreStateAOD : store.state.AOD,
            StoreStateED : store.state.ED
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>